import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-673ae7e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "request-container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Push Notifications", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, " Be notified of new Notices and Feedback so you can make every customer experience awesome. ", -1))
const _hoisted_4 = { class: "button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_BaseButton, {
            round: "",
            primary: "",
            click: _ctx.onClick
          }, {
            default: _withCtx(() => [
              _createTextVNode("Turn on Notifications")
            ], undefined, true),
            _: 1
          }, 8, ["click"])
        ])
      ]))
    : _createCommentVNode("", true)
}